export default "__VITE_ASSET__DYwGXyup__$_?nuxt_component=async&nuxt_component_name=Svgo404&nuxt_component_export=default__"